export default __webpack_public_path__ + "static/pushing-water-0047f5d5739dd8c966aee45fd2051339.jpg";